import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { MapPage } from '../map/map';
import { FavoritesPage } from '../favorites/favorites';
import { SearchPage } from '../search/search';

@Component({
  selector: 'page-tabs-controller',
  templateUrl: 'tabs-controller.html'
})
export class TabsControllerPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  tab1Root: any = MapPage;
  tab2Root: any = FavoritesPage;
  tab3Root: any = SearchPage;
  constructor(public navCtrl: NavController) {
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/tabs-controller/tabs-controller.ts